import React from 'react';
import { Link } from "react-router-dom";
import { Accordion, Button, Card, Container, Form, FormControl, FormLabel, Image } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "../general.css";

const Puzzle = ({ en }) => {
  return (
    <>
      {en ? (
        <>When you have solved the quiz, enter your answer in the password input field.</>
      ) : (
        <>
          <p>それぞれの謎の答えが解ったら、<br />パスワード欄に入力しよう！</p>
        </>
      )}
      <div className='text-start'>
        <hr />
        <h3>{en ? "Peddler's Quiz" : "行商人の謎"}</h3>
        <p>
          {en ? "What was the year of Muhammad's death?" : "ムハンマドが亡くなったのは西暦何年？"}
        </p>
        <hr />
        <h3>{en ? "Rock Painting's Quiz" : "岩絵の謎"}</h3>
        <p className='text-center fs-3'>
          「①②③④」
        </p>
        <hr />
        <h3>{en ? "Sand Pit's Quiz" : "砂場の謎"}</h3>
        <p>
          {en ? <>
            Avicennia marina can collect in Japan of limited place.<br />Which prefecture can collect Avicennia marina?
          </> : <>
            ヒルギダマシは日本でも1つの県で取れます。
            <br />
            どの県で取れるでしょう？
          </>}
        </p>
        <hr />
        <h3>{en ? "Camel's Quiz" : "ラクダの謎"}</h3>
        <Image src='/img/camel_quiz.png' width="100%" />
        <p className='text-center fs-3'>「②③①④」</p>
        <hr />
      </div>
    </>
  )
}

export default Puzzle;
